/**
 * postMessage type strings for the loader <-> iframe embed contract.
 * The web app and web-embeds-v2 must emit and listen for these exact values.
 */

/**
 * Message types for parent -> iframe communication
 */
export const PARENT_MESSAGE_TYPES = {
  /** Initialize embed context in web app */
  EMBED_INIT: "APOLLOS_EMBED_INIT",
  /** Notify web app of fullscreen state change */
  FULLSCREEN_CHANGED: "APOLLOS_FULLSCREEN_CHANGED",
  /** Notify web app of theme mode change */
  THEME_CHANGED: "APOLLOS_THEME_CHANGED",
} as const;

/**
 * Message types for iframe -> parent communication
 */
export const IFRAME_MESSAGE_TYPES = {
  /** Web app mounted and ready to receive messages */
  EMBED_READY: "APOLLOS_EMBED_READY",
  /** Web app loaded and ready */
  EMBED_UPDATE: "APOLLOS_EMBED_UPDATE",
  /** Internal navigation occurred */
  NAVIGATION: "APOLLOS_NAVIGATION",
  /** User clicked close button in web app navbar */
  REQUEST_CLOSE: "APOLLOS_REQUEST_CLOSE",
  /** User clicked expand button in web app navbar */
  REQUEST_FULLSCREEN: "APOLLOS_REQUEST_FULLSCREEN",
  /** Web app requests opening external URL in new tab */
  OPEN_EXTERNAL: "APOLLOS_OPEN_EXTERNAL",
  /** Inline embed requests parent to open path in modal (for navigation handoff) */
  REQUEST_NAVIGATION: "APOLLOS_REQUEST_NAVIGATION",
  /** Inline embed reports content height for auto-resize */
  HEIGHT_CHANGE: "APOLLOS_HEIGHT_CHANGE",
  /** Modal iframe reports route-level presentation options */
  MODAL_OPTIONS: "APOLLOS_MODAL_OPTIONS",
} as const;
